import { useEffect, useState } from "react";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faA, faAdd, faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import ToggleSwitch from "../../components/toggleSwitch";
import TextEditor from "../../components/textEditor/textEditor";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import toast from "react-hot-toast";
import { isValidURL } from "../../utils/isValidUrl";
import he from "he";

const Service = () => {
  const [hero, setHero] = useState([]);
  const [fold1Title, setFold1Title] = useState("");
  const [fold1List, setFold1List] = useState([]);
  const [fold2Text, setFold2Text] = useState("");
  const [fold2List, setFold2List] = useState([]);
  const [stackHeading, setStackHeading] = useState("");
  const [stackDescription, setStackDescription] = useState("");
  const [stackButtonShow, setStackButtonShow] = useState(false);
  const [stackButtonText, setStackButtonText] = useState("");
  const [stackButtonUrl, setStackButtonUrl] = useState("");
  const [fold3Heading, setFold3Heading] = useState("");
  const [fold3Description, setFold3Description] = useState("");
  const [fold3Numbers, setFold3Numbers] = useState([]);
  const [fold3ButtonShow, setFold3ButtonShow] = useState(false);
  const [fold3ButtonText, setFold3ButtonText] = useState("");
  const [fold3ButtonUrl, setFold3ButtonUrl] = useState("");
  const [fold3Achievements, setFold3Achievements] = useState([]);
  const [fold4Content, setFold4Content] = useState("");
  const [fold4ButtonShow, setFold4ButtonShow] = useState(false);
  const [fold4ButtonText, setFold4ButtonText] = useState("");
  const [fold4ButtonUrl, setFold4ButtonUrl] = useState("");
  const [fold5List, setFold5List] = useState([]);
  const [fold6Heading, setFold6Heading] = useState("");
  const [fold6SubHeading, setFold6SubHeading] = useState("");
  const [fold6ButtonShow, setFold6ButtonShow] = useState(false);
  const [fold6ButtonText, setFold6ButtonText] = useState("");
  const [fold6ButtonUrl, setFold6ButtonUrl] = useState("");
  const [fold6Methodologies, setFold6Methodologies] = useState([]);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [slug, setSlug] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [navbar, setNavbar] = useState({
    image: { url: "", obj: "" },
    imageCaption: "",
    imageAlt: "",
    heading: "",
    description: "",
  });

  const [loading, setLoading] = useState(true);
  const [isChanged, setIsChanged] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [id, setId] = useState("");

  useEffect(() => {
    getBlogs();
  }, []);

  const getBlogs = () => {
    getAllApi("article")
      .then((response) => {
        setBlogs(response.data);
        getData();
      })
      .catch((error) => {
        setBlogs([]);
        toast.error("Something went wrong while fetching blogs.");
        getData();
      });
  };

  const getData = () => {
    getAllApi("service")
      .then((res) => {
        if (res.data.length !== 0) {
          setId(res.data[0]._id);
          const val = res.data[0];

          console.log(val);

          setHero(
            val.hero.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
              description: he.decode(v?.description || ""),
            }))
          );
          setNavbar({
            ...val.navbar,
            image: { url: val.navbar.image, obj: "" },
          });
          setFold1Title(val.fold_1?.title);
          setFold1List(
            val?.fold_1?.details?.map((v) => ({
              ...v,
              icon: { url: v.icon, obj: "" },
              description: he.decode(v.description),
            }))
          );
          setFold2Text(he.decode(val.fold_2?.text || ""));
          setFold2List(
            val?.fold_2?.companies?.map((v) => ({
              ...v,
              icon: { url: v.icon, obj: "" },
            }))
          );
          setStackHeading(val?.stack?.heading);
          setStackDescription(he.decode(val?.stack?.description || ""));
          setStackButtonShow(val?.stack?.buttonShow);
          setStackButtonText(val?.stack?.buttonText);
          setStackButtonUrl(val?.stack?.buttonUrl);
          setFold3Heading(val?.fold_3?.heading);
          setFold3Description(he.decode(val?.fold_3?.description));
          setFold3Numbers(val?.fold_3?.numbers);
          setFold3ButtonShow(val?.fold_3?.buttonShow);
          setFold3ButtonText(val?.fold_3?.buttonText);
          setFold3ButtonUrl(val?.fold_3?.buttonUrl);
          setFold3Achievements(
            val?.fold_3?.achievements?.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
            }))
          );
          setFold4Content(he.decode(val?.fold_4?.content || ""));
          setFold4ButtonShow(val?.fold_4?.buttonShow);
          setFold4ButtonText(val?.fold_4?.buttonText);
          setFold4ButtonUrl(val?.fold_4?.buttonUrl);
          setFold5List(
            val?.fold_5?.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
            }))
          );
          setFold6Heading(val?.fold_6?.heading);
          setFold6SubHeading(val?.fold_6?.subHeading);
          setFold6ButtonShow(val?.fold_6?.buttonShow);
          setFold6ButtonText(val?.fold_6?.buttonText);
          setFold6ButtonUrl(val?.fold_6?.buttonUrl);
          setFold6Methodologies(
            val?.fold_6?.methodologies?.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
            }))
          );
          setRelatedBlogs(val?.relatedArticle?.map((v) => v._id) || []);
          setSlug(val?.metaData?.slug);
          setMetaTitle(val?.metaData?.metaTitle);
          setMetaImageUrl(val?.metaData?.metaImageUrl);
          setMetaDescription(val?.metaData?.metaDescription);
          setCanonicalUrl(val?.metaData?.canonicalUrl);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const validate = () => {
    const validationCheck = [
      { condition: hero.length === 0, message: "Hero is required." },
      {
        condition: hero.some((v) => !v.image.url),
        message: "Hero Image is required.",
      },
      {
        condition: hero.some((v) => !v.imageCaption),
        message: "Hero Image Caption is required.",
      },
      {
        condition: hero.some((v) => !v.imageAlt),
        message: "Hero Image Alt is required.",
      },
      {
        condition: hero.some((v) => !v.title),
        message: "Hero Title is required.",
      },
      {
        condition: hero.some((v) => v.buttonShow && !v.buttonText),
        message: "Hero Button Text is required.",
      },
      {
        condition: hero.some((v) => v.buttonShow && !v.buttonUrl),
        message: "Hero Button Url is required.",
      },
      {
        condition: hero.some((v) => v.buttonShow && !isValidURL(v.buttonUrl)),
        message: "Hero Button Url is invalid.",
      },
      {
        condition: hero.some((v) => !v.description),
        message: "Hero Description is required.",
      },
      {
        condition: fold1List.length === 0,
        message: "Fold 1 is required.",
      },
      {
        condition: !fold1Title,
        message: "Fold 1 Title is required.",
      },
      {
        condition: fold1List.some((v) => !v.icon.url),
        message: "Fold 1 Icon is required.",
      },
      {
        condition: fold1List.some((v) => !v.iconCaption),
        message: "Fold 1 Icon Caption is required.",
      },
      {
        condition: fold1List.some((v) => !v.iconAlt),
        message: "Fold 1 Icon Alt is required.",
      },
      {
        condition: fold1List.some((v) => !v.heading),
        message: "Fold 1 Heading is required.",
      },
      {
        condition: fold1List.some((v) => !v.description),
        message: "Fold 1 Description is required.",
      },
      {
        condition: fold2List.length === 0,
        message: "Fold 2 is required.",
      },
      {
        condition: !fold2Text,
        message: "Fold 2 Content is required.",
      },
      {
        condition: fold2List.some((v) => !v.icon?.url),
        message: "Fold 2 Icon is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconCaption),
        message: "Fold 2 Icon Caption is required.",
      },
      {
        condition: fold2List.some((v) => !v.iconAlt),
        message: "Fold 2 Icon Alt is required.",
      },
      {
        condition: !stackHeading,
        message: "Stack Section heading is required.",
      },
      {
        condition: stackButtonShow && !stackButtonText,
        message: "Stack Section button text is required.",
      },
      {
        condition: stackButtonShow && !stackButtonUrl,
        message: "Stack Section button url is required.",
      },
      {
        condition: stackButtonShow && !isValidURL(stackButtonUrl),
        message: "Stack Section button url is invalid.",
      },
      {
        condition: !stackDescription,
        message: "Stack Section description is required.",
      },
      {
        condition: !fold3Heading,
        message: "Fold 3 Heading is required.",
      },
      {
        condition: fold3ButtonShow && !fold3ButtonText,
        message: "Fold 3 Button Text is required.",
      },
      {
        condition: fold3ButtonShow && !fold3ButtonUrl,
        message: "Fold 3 Button Url is required.",
      },
      {
        condition: fold3ButtonShow && !isValidURL(fold3ButtonUrl),
        message: "Fold 3 Button Url is invalid.",
      },
      {
        condition: !fold3Description,
        message: "Fold 3 description is required.",
      },
      {
        condition: fold3Numbers.length === 0,
        message: "Fold 3 Numbers are required.",
      },
      {
        condition: fold3Numbers.some((v) => !v.number),
        message: "Fold 3 in Number list number is required.",
      },
      {
        condition: fold3Numbers.some((v) => !v.text),
        message: "Fold 3 in Number list text is required.",
      },
      {
        condition: fold3Achievements.length === 0,
        message: "Fold 3 Achievements are required.",
      },
      {
        condition: fold3Achievements.some((v) => !v.image.url),
        message: "Fold 3 Achievement's list image is required.",
      },
      {
        condition: fold3Achievements.some((v) => !v.imageCaption),
        message: "Fold 3 Achievement's list image caption is required.",
      },
      {
        condition: fold3Achievements.some((v) => !v.imageAlt),
        message: "Fold 3 Achievement's list image alt is required.",
      },
      {
        condition: fold3Achievements.some((v) => !v.text),
        message: "Fold 3 Achievement's list text is required.",
      },
      {
        condition: !fold4Content,
        message: "Fold 4 Content is required.",
      },
      {
        condition: fold4ButtonShow && !fold4ButtonText,
        message: "Fold 4 Button Text is required.",
      },
      {
        condition: fold4ButtonShow && !fold4ButtonUrl,
        message: "Fold 4 Button Url is required.",
      },
      {
        condition: fold4ButtonShow && !isValidURL(fold4ButtonUrl),
        message: "Fold 4 Button url is invalid.",
      },
      {
        condition: !fold6Heading,
        message: "Fold 5 Heading is required.",
      },
      {
        condition: !fold6SubHeading,
        message: "Fold 5 Sub Heading is required.",
      },
      {
        condition: fold6ButtonShow && !fold6ButtonText,
        message: "Fold 5 Button Text is required.",
      },
      {
        condition: fold6ButtonShow && !fold6ButtonUrl,
        message: "Fold 5 Button Url is required.",
      },
      {
        condition: fold6ButtonShow && !isValidURL(fold6ButtonUrl),
        message: "Fold 5 Button Url is invalid.",
      },
      {
        condition: fold6Methodologies.length === 0,
        message: "Fold 5 Methodologies are required.",
      },
      {
        condition: fold6Methodologies.some((v) => !v.image.url),
        message: "Fold 5 methodologies Image is required.",
      },
      {
        condition: fold6Methodologies.some((v) => !v.imageCaption),
        message: "Fold 5 Methodologies Image caption is required.",
      },
      {
        condition: fold6Methodologies.some((v) => !v.imageAlt),
        message: "Fold 5 Methodologies Image Alt is required.",
      },
      {
        condition: fold6Methodologies.some((v) => !v.title),
        message: "Fold 5 Methodologies Title is required.",
      },
      {
        condition: relatedBlogs.length === 0,
        message: "Related Articles are required.",
      },
      {
        condition: !navbar.image.url,
        message: "Navbar Image is required.",
      },
      {
        condition: !navbar.imageCaption,
        message: "Navbar Image Caption is required.",
      },
      {
        condition: !navbar.imageAlt,
        message: "Navbar Image Alt is required.",
      },
      {
        condition: !navbar.heading,
        message: "Navbar Heading is required.",
      },
      {
        condition: !navbar.description,
        message: "Navbar Description is required.",
      },
      {
        condition: !slug,
        message: "Slug is required.",
      },
      {
        condition: !metaTitle,
        message: "Meta title is required.",
      },
      {
        condition: !metaImageUrl,
        message: "Meta Image url is required.",
      },
      {
        condition: !isValidURL(metaImageUrl),
        message: "Meta Image Url is invalid.",
      },
      {
        condition: !metaDescription,
        message: "Meta Description is required.",
      },
      {
        condition: !canonicalUrl,
        message: "Canonical Url is required.",
      },
      {
        condition: !isValidURL(canonicalUrl),
        message: "Canonical Url is invalid.",
      },
    ];

    for (const check of validationCheck) {
      if (check.condition) {
        toast.error(check.message);
        return false;
      }
    }
    return true;
  };

  const getHero = async () => {
    let value = [];

    for (let i = 0; i < hero.length; i++) {
      const temp = hero[i];

      if (temp.image.obj) {
        const r = await uploadImageApi(temp.image.obj);
        value.push({ ...hero[i], image: r.data.imageUrl });
      } else {
        value.push({ ...hero[i], image: temp.image.url });
      }
    }

    return value;
  };

  const getFold1List = async () => {
    let value = [];

    for (let i = 0; i < fold1List.length; i++) {
      const temp = fold1List[i];

      if (temp.icon.obj) {
        const r = await uploadImageApi(temp.icon.obj);
        value.push({ ...fold1List[i], icon: r.data.imageUrl });
      } else {
        value.push({ ...fold1List[i], icon: temp.icon.url });
      }
    }

    return value;
  };

  const getFold2List = async () => {
    let value = [];

    for (let i = 0; i < fold2List.length; i++) {
      const temp = fold2List[i];

      if (temp.icon.obj) {
        const r = await uploadImageApi(temp.icon.obj);
        value.push({ ...fold2List[i], icon: r.data.imageUrl });
      } else {
        value.push({ ...fold2List[i], icon: temp.icon.url });
      }
    }

    return value;
  };

  const getFold3Achivements = async () => {
    let value = [];

    for (let i = 0; i < fold3Achievements.length; i++) {
      const temp = fold3Achievements[i];

      if (temp.image.obj) {
        const r = await uploadImageApi(temp.image.obj);
        value.push({ ...fold3Achievements[i], image: r.data.imageUrl });
      } else {
        value.push({ ...fold3Achievements[i], image: temp.image.url });
      }
    }

    return value;
  };

  const getFold5 = async () => {
    let value = [];

    for (let i = 0; i < fold5List.length; i++) {
      const temp = fold5List[i];

      if (temp.image.obj) {
        const r = await uploadImageApi(temp.image.obj);
        value.push({ ...fold5List[i], image: r.data.imageUrl });
      } else {
        value.push({ ...fold5List[i], image: temp.image.url });
      }
    }

    return value;
  };

  const getMethodologies = async () => {
    let value = [];

    for (let i = 0; i < fold6Methodologies.length; i++) {
      const temp = fold6Methodologies[i];

      if (temp.image.obj) {
        const r = await uploadImageApi(temp.image.obj);
        value.push({ ...fold6Methodologies[i], image: r.data.imageUrl });
      } else {
        value.push({ ...fold6Methodologies[i], image: temp.image.url });
      }
    }

    return value;
  };

  const getNavbarData = async () => {
    let n_d = {
      heading: navbar.heading,
      description: navbar.description,
      imageCaption: navbar.imageCaption,
      imageAlt: navbar.imageAlt,
    };

    if (navbar.image.obj) {
      const r = await uploadImageApi(navbar.image.obj);
      n_d.image = r.data.imageUrl;
    } else {
      n_d.image = navbar.image.url;
    }

    return n_d;
  };

  const handleSubmit = async () => {
    if (validate()) {
      setLoading(true);

      const data = {
        hero: await getHero(),
        fold_1: {
          title: fold1Title,
          details: await getFold1List(),
        },
        fold_2: {
          text: fold2Text,
          companies: await getFold2List(),
        },
        stack: {
          heading: stackHeading,
          description: stackDescription,
          buttonShow: stackButtonShow,
          buttonText: stackButtonText,
          buttonUrl: stackButtonUrl,
        },
        fold_3: {
          heading: fold3Heading,
          description: fold3Description,
          numbers: fold3Numbers,
          buttonShow: fold3ButtonShow,
          buttonText: fold3ButtonText,
          buttonUrl: fold3ButtonUrl,
          achievements: await getFold3Achivements(),
        },
        fold_4: {
          content: fold4Content,
          buttonShow: fold4ButtonShow,
          buttonText: fold4ButtonText,
          buttonUrl: fold4ButtonUrl,
        },
        fold_5: await getFold5(),
        fold_6: {
          heading: fold6Heading,
          subHeading: fold6SubHeading,
          buttonShow: fold6ButtonShow,
          buttonText: fold6ButtonText,
          buttonUrl: fold6ButtonUrl,
          methodologies: await getMethodologies(),
        },
        relatedArticle: relatedBlogs,
        navbar: await getNavbarData(),
        metaData: {
          slug,
          metaTitle,
          metaImageUrl,
          metaDescription,
          canonicalUrl,
        },
      };

      addUpdateApi({ data, type: "service", method: "patch", id })
        .then((res) => {
          toast.success("Updated Successfully.");
          setLoading(false);
        })
        .catch((err) => {
          toast.error("Something went wrong.");
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Content>
        <ContentHead
          title="Service"
          showBtn1={isChanged}
          btn1Text="Save"
          btn1Name="btn1"
          btn1type="filled"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2Name="btn2"
          btn2type="outlined_del"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleSubmit();
            } else {
              setIsChanged(false);
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            {/* Hero Carousel */}
            <div className="card grid">
              <h3>
                Hero Carousel
                <button
                  onClick={() => {
                    setHero((prev) => [
                      ...prev,
                      {
                        image: { url: "", obj: "" },
                        imageCaption: "",
                        imageAlt: "",
                        title: "",
                        description: "",
                        buttonShow: false,
                        buttonText: "",
                        buttonUrl: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  Add
                </button>
              </h3>
              {hero.map((h, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      className="sub_card_close"
                      icon={faClose}
                      onClick={() => {
                        const temp = [...hero];
                        temp.splice(index, 1);
                        setHero(temp);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {h.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...hero];
                              temp[index].image = { url: "", obj: "" };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={h.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {h.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={h.imageCaption}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageCaption = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={h.imageAlt}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageAlt = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <InputField
                      type="text"
                      value={h.title}
                      onChange={(e) => {
                        let temp = [...hero];
                        temp[index].title = e.target.value;
                        setHero(temp);
                        setIsChanged(true);
                      }}
                      isLabel={true}
                      lable="Title"
                    />
                    <div className="grid_2">
                      <div
                        style={{
                          height: "50px",
                          width: "100%",
                          border: "1px solid lightgrey",
                          background: "white",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          paddingInline: "15px",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <p>Show Button</p>
                        <ToggleSwitch
                          value={h.buttonShow}
                          onClick={() => {
                            let temp = [...hero];
                            temp[index].buttonShow = !h.buttonShow;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                      {h.buttonShow && (
                        <>
                          <InputField
                            type="text"
                            isLabel={true}
                            value={h.buttonText}
                            lable="Button Text"
                            placeholder="Enter button text"
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].buttonText = e.target.value;
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            value={h.buttonUrl}
                            lable="Button Link"
                            placeholder="Enter button Link"
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].buttonUrl = e.target.value;
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                        </>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        marginTop: "5px",
                      }}
                    >
                      <p style={{ paddingLeft: "5px" }}>Description</p>
                      <TextEditor
                        content={h.description}
                        handleChange={(v) => {
                          let temp = [...hero];
                          temp[index].description = v;
                          setHero(temp);
                          setIsChanged(true);
                        }}
                        smallEditor={false}
                      />
                    </div>
                    {/* <InputField
                      type="textarea"
                      value={h.description}
                      onChange={(e) => {
                        let temp = [...hero];
                        temp[index].description = e.target.value;
                        setHero(temp);
                        setIsChanged(true);
                      }}
                      isLabel={true}
                      lable="Description"
                    /> */}
                  </div>
                );
              })}
            </div>
            {/* Fold 1 */}
            <div className="card grid">
              <h3>
                Fold 1{" "}
                <button
                  onClick={() => {
                    setFold1List((prev) => [
                      ...prev,
                      {
                        icon: { url: "", obj: "" },
                        iconCaption: "",
                        iconAlt: "",
                        heading: "",
                        description: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold1List.length !== 0 && (
                <InputField
                  value={fold1Title}
                  isLabel={true}
                  lable="Title"
                  onChange={(e) => setFold1Title(e.target.value)}
                />
              )}
              {fold1List.map((fl, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        const temp = [...fold1List];
                        temp.splice(index, 1);
                        setFold1List(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Icon</p>
                      {fl.icon.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...fold1List];
                              temp[index].icon = { url: "", obj: "" };
                              setFold1List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={fl.icon.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...fold1List];
                              temp[index].icon = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setFold1List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {fl.icon?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Icon Caption"}
                          value={fl.iconCaption}
                          onChange={(e) => {
                            let temp = [...fold1List];
                            temp[index].iconCaption = e.target.value;
                            setFold1List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Icon Alt"}
                          value={fl.iconAlt}
                          onChange={(e) => {
                            let temp = [...fold1List];
                            temp[index].iconAlt = e.target.value;
                            setFold1List(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <div className="grid">
                      <InputField
                        value={fl.heading}
                        isLabel={true}
                        lable="Heading"
                        onChange={(e) => {
                          const temp = [...fold1List];
                          temp[index].heading = e.target.value;
                          setFold1List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          marginTop: "5px",
                        }}
                      >
                        <p style={{ paddingLeft: "5px" }}>Description</p>
                        <TextEditor
                          handleChange={(val) => {
                            let temp = [...fold1List];
                            temp[index].description = val;
                            setFold1List(temp);
                            setIsChanged(true);
                          }}
                          content={fl.description}
                          smallEditor={true}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* Fold 2 */}
            <div className="card grid">
              <h3>
                Fold 2{" "}
                <button
                  onClick={() => {
                    setFold2List((prev) => [
                      ...prev,
                      {
                        icon: { url: "", obj: "" },
                        iconCaption: "",
                        iconAlt: "",
                      },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              {fold2List.length !== 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    marginTop: "5px",
                  }}
                >
                  <p style={{ paddingLeft: "5px" }}>Content</p>
                  <TextEditor
                    handleChange={(val) => {
                      setFold2Text(val);
                      setIsChanged(true);
                    }}
                    content={fold2Text}
                    smallEditor={true}
                  />
                </div>
              )}
              {fold2List.map((value, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      className="sub_card_close"
                      icon={faClose}
                      onClick={() => {
                        const temp = [...fold2List];
                        temp.splice(index, 1);
                        setFold2List(temp);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Icon</p>
                      {value.icon.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...fold2List];
                              temp[index].icon = { url: "", obj: "" };
                              setFold2List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.icon.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...fold2List];
                              temp[index].icon = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setFold2List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Icon Caption"}
                        value={value.iconCaption}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconCaption = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Icon Alt"}
                        value={value.iconAlt}
                        onChange={(e) => {
                          let temp = [...fold2List];
                          temp[index].iconAlt = e.target.value;
                          setFold2List(temp);
                          setIsChanged(true);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            {/* Stack */}
            <div className="card grid">
              <h3>Stack Section</h3>
              <InputField
                isLabel={true}
                lable="Heading"
                value={stackHeading}
                onChange={(e) => {
                  setStackHeading(e.target.value);
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={stackButtonShow}
                    onClick={() => {
                      setStackButtonShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {stackButtonShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={stackButtonText}
                      lable="Button Text"
                      placeholder="Enter button text"
                      onChange={(e) => {
                        setStackButtonText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      value={stackButtonUrl}
                      lable="Button Url"
                      placeholder="Enter button Link"
                      onChange={(e) => {
                        setStackButtonUrl(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setStackDescription(val);
                    setIsChanged(true);
                  }}
                  content={stackDescription}
                  smallEditor={true}
                />
              </div>
            </div>
            {/* Fold 3 */}
            <div className="card grid">
              <h3>Fold 3</h3>
              <InputField
                isLabel={true}
                lable="Heading"
                value={fold3Heading}
                onChange={(e) => {
                  setFold3Heading(e.target.value);
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold3ButtonShow}
                    onClick={() => {
                      setFold3ButtonShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold3ButtonShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold3ButtonText}
                      lable="Button Text"
                      placeholder="Enter button text"
                      onChange={(e) => {
                        setFold3ButtonText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold3ButtonUrl}
                      lable="Button Url"
                      placeholder="Enter button Link"
                      onChange={(e) => {
                        setFold3ButtonUrl(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Description</p>
                <TextEditor
                  handleChange={(val) => {
                    setFold3Description(val);
                    setIsChanged(true);
                  }}
                  content={fold3Description}
                  smallEditor={true}
                />
              </div>
              <h3>
                Numbers{" "}
                <button
                  onClick={() => {
                    setFold3Numbers((prev) => [
                      ...prev,
                      { number: "", text: "" },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold3Numbers.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="sub_card grid_2"
                    style={{ borderWidth: "1px" }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        const temp = [...fold3Numbers];
                        temp.splice(index, 1);
                        setFold3Numbers(temp);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="number"
                      isLabel={true}
                      lable="Number"
                      value={value.number}
                      onChange={(e) => {
                        const temp = [...fold3Numbers];
                        temp[index].number = e.target.value;
                        setFold3Numbers(temp);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable="Text"
                      value={value.text}
                      onChange={(e) => {
                        const temp = [...fold3Numbers];
                        temp[index].text = e.target.value;
                        setFold3Numbers(temp);
                        setIsChanged(true);
                      }}
                    />
                  </div>
                );
              })}
              <h3>
                Achievements{" "}
                <button
                  onClick={() => {
                    setFold3Achievements((prev) => [
                      ...prev,
                      {
                        image: { url: "", obj: "" },
                        imageCaption: "",
                        imageAlt: "",
                        text: "",
                      },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold3Achievements.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="sub_card grid"
                    style={{ borderWidth: "1px" }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        const temp = [...fold3Achievements];
                        temp.splice(index, 1);
                        setFold3Achievements(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {value.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...fold3Achievements];
                              temp[index].image = { url: "", obj: "" };
                              setFold3Achievements(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...fold3Achievements];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setFold3Achievements(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {value.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={value.imageCaption}
                          onChange={(e) => {
                            let temp = [...fold3Achievements];
                            temp[index].imageCaption = e.target.value;
                            setFold3Achievements(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Icon Alt"}
                          value={value.imageAlt}
                          onChange={(e) => {
                            let temp = [...fold3Achievements];
                            temp[index].imageAlt = e.target.value;
                            setFold3Achievements(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <InputField
                      isLabel={true}
                      lable="Text"
                      value={value.text}
                      onChange={(e) => {
                        const temp = [...fold3Achievements];
                        temp[index].text = e.target.value;
                        setFold3Achievements(temp);
                        setIsChanged(true);
                      }}
                    />
                  </div>
                );
              })}
            </div>
            {/* Fold 4 */}
            <div className="card grid">
              <h3>Fold 4</h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <p style={{ paddingLeft: "5px" }}>Content</p>
                <TextEditor
                  handleChange={(val) => {
                    setFold4Content(val);
                    setIsChanged(true);
                  }}
                  content={fold4Content}
                  smallEditor={true}
                />
              </div>
              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold4ButtonShow}
                    onClick={() => {
                      setFold4ButtonShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold4ButtonShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold4ButtonText}
                      lable="Button Text"
                      placeholder="Enter button text"
                      onChange={(e) => {
                        setFold4ButtonText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold4ButtonUrl}
                      lable="Button Url"
                      placeholder="Enter button Link"
                      onChange={(e) => {
                        setFold4ButtonUrl(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            {/* Fold 5 */}
            {/* <div className="card grid">
              <h3>
                Fold 5{" "}
                <button
                  onClick={() => {
                    setFold5List((prev) => [
                      ...prev,
                      {
                        title: "",
                        subTitle: "",
                        buttonShow: false,
                        buttonText: "",
                        buttonUrl: "",
                        image: { url: "", obj: "" },
                        imageCaption: "",
                        imageAlt: "",
                      },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} />
                  Add
                </button>
              </h3>
              {fold5List.map((value, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        const temp = [...fold5List];
                        temp.splice(index, 1);
                        setFold5List(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {value.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...fold5List];
                              temp[index].image = { url: "", obj: "" };
                              setFold5List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...fold5List];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setFold5List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {value.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={value.imageCaption}
                          onChange={(e) => {
                            let temp = [...fold5List];
                            temp[index].imageCaption = e.target.value;
                            setFold5List(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={value.imageAlt}
                          onChange={(e) => {
                            let temp = [...fold5List];
                            temp[index].imageAlt = e.target.value;
                            setFold5List(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <InputField
                      isLabel={true}
                      lable="Title"
                      value={value.title}
                      onChange={(e) => {
                        const temp = [...fold5List];
                        temp[index].title = e.target.value;
                        setFold5List(temp);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      isLabel={true}
                      lable="Sub Title"
                      value={value.subTitle}
                      onChange={(e) => {
                        const temp = [...fold5List];
                        temp[index].subTitle = e.target.value;
                        setFold5List(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div className="grid_2">
                      <div
                        style={{
                          height: "50px",
                          width: "100%",
                          border: "1px solid lightgrey",
                          background: "white",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          paddingInline: "15px",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <p>Show Button</p>
                        <ToggleSwitch
                          value={value.buttonShow}
                          onClick={() => {
                            const temp = [...fold5List];
                            temp[index].buttonShow = !value.buttonShow;
                            setFold5List(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                      {value.buttonShow && (
                        <>
                          <InputField
                            type="text"
                            isLabel={true}
                            value={value.buttonText}
                            lable="Button Text"
                            placeholder="Enter button text"
                            onChange={(e) => {
                              const temp = [...fold5List];
                              temp[index].buttonText = e.target.value;
                              setFold5List(temp);
                              setIsChanged(true);
                            }}
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            value={value.buttonUrl}
                            lable="Button Url"
                            placeholder="Enter button Link"
                            onChange={(e) => {
                              const temp = [...fold5List];
                              temp[index].buttonUrl = e.target.value;
                              setFold5List(temp);
                              setIsChanged(true);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div> */}
            {/* Fold 6 */}
            <div className="card grid">
              <h3>Fold 5</h3>
              <InputField
                isLabel={true}
                lable="Heading"
                value={fold6Heading}
                onChange={(e) => {
                  setFold6Heading(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Sub Heading"
                value={fold6SubHeading}
                onChange={(e) => {
                  setFold6SubHeading(e.target.value);
                  setIsChanged(true);
                }}
              />
              <div className="grid_2">
                <div
                  style={{
                    height: "50px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingInline: "15px",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <p>Show Button</p>
                  <ToggleSwitch
                    value={fold6ButtonShow}
                    onClick={() => {
                      setFold6ButtonShow((prev) => !prev);
                      setIsChanged(true);
                    }}
                  />
                </div>
                {fold6ButtonShow && (
                  <>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold6ButtonText}
                      lable="Button Text"
                      placeholder="Enter button text"
                      onChange={(e) => {
                        setFold6ButtonText(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      value={fold6ButtonUrl}
                      lable="Button Url"
                      placeholder="Enter button Link"
                      onChange={(e) => {
                        setFold6ButtonUrl(e.target.value);
                        setIsChanged(true);
                      }}
                    />
                  </>
                )}
              </div>
              <h3>
                Methodologies{" "}
                <button
                  onClick={() => {
                    setFold6Methodologies((prev) => [
                      ...prev,
                      {
                        image: { url: "", obj: "" },
                        imageCaption: "",
                        imageAlt: "",
                        title: "",
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faAdd} /> Add
                </button>
              </h3>
              {fold6Methodologies.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="sub_card grid"
                    style={{ borderWidth: "1px" }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      className="sub_card_close"
                      onClick={() => {
                        const temp = [...fold6Methodologies];
                        temp.splice(index, 1);
                        setFold6Methodologies(temp);
                        setIsChanged(true);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {value.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...fold6Methodologies];
                              temp[index].image = { url: "", obj: "" };
                              setFold6Methodologies(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={value.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...fold6Methodologies];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setFold6Methodologies(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {value.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={value.imageCaption}
                          onChange={(e) => {
                            let temp = [...fold6Methodologies];
                            temp[index].imageCaption = e.target.value;
                            setFold6Methodologies(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Icon Alt"}
                          value={value.imageAlt}
                          onChange={(e) => {
                            let temp = [...fold6Methodologies];
                            temp[index].imageAlt = e.target.value;
                            setFold6Methodologies(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <InputField
                      isLabel={true}
                      lable="Heading"
                      value={value.title}
                      onChange={(e) => {
                        const temp = [...fold6Methodologies];
                        temp[index].title = e.target.value;
                        setFold6Methodologies(temp);
                        setIsChanged(true);
                      }}
                    />
                  </div>
                );
              })}
            </div>
            {/* Related Articles */}
            <div className="card grid">
              <h3>Related Articles</h3>
              <InputField
                type="select"
                options={blogs.filter((val) => {
                  const temp = relatedBlogs.filter((v) => v === val._id);
                  return temp.length === 0 ? true : false;
                })}
                accessText="blogTitle"
                accessValue="_id"
                value=""
                onChange={(e) => {
                  setRelatedBlogs((prev) => [...prev, e.target.value]);
                  setIsChanged(true);
                }}
              />
              <div className="grid_3">
                {relatedBlogs.map((value, index) => {
                  return (
                    <div key={index} className="sub_card">
                      <FontAwesomeIcon
                        icon={faClose}
                        className="sub_card_close"
                        onClick={() => {
                          let temp = [...relatedBlogs];
                          temp.splice(index, 1);
                          setRelatedBlogs(temp);
                          setIsChanged(true);
                        }}
                      />
                      <img
                        style={{
                          width: "100%",
                          aspectRatio: "1/1",
                          objectFit: "cover",
                        }}
                        src={
                          blogs.filter((val) => val._id === value)[0]?.blogImage
                        }
                        alt=""
                      />
                      <p>
                        {blogs.filter((val) => val._id === value)[0]?.blogTitle}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Nav bar content */}
            <div className="card grid">
              <h3>NavBar Service Content</h3>
              <div>
                <p style={{ fontSize: ".9rem" }}>Image</p>
                {navbar.image.url ? (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                      position: "relative",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      style={{
                        color: "var(--blue-dark)",
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        padding: "5px",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        transform: "translate(50%, -50%)",
                      }}
                      onClick={() => {
                        setNavbar((prev) => ({
                          ...prev,
                          image: { url: "", obj: "" },
                        }));
                        setIsChanged(true);
                      }}
                    />
                    <img
                      src={navbar.image.url}
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      position: "relative",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    <input
                      type="file"
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        opacity: 0,
                      }}
                      accept="image/*"
                      onChange={(e) => {
                        setNavbar((prev) => ({
                          ...prev,
                          image: {
                            url: URL.createObjectURL(e.target.files[0]),
                            obj: e.target.files[0],
                          },
                        }));
                        setIsChanged(true);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ color: "var(--blue-dark)" }}
                    />
                  </div>
                )}
              </div>
              {navbar.image?.url && (
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Caption"}
                    value={navbar.imageCaption}
                    onChange={(e) => {
                      setNavbar((prev) => ({
                        ...prev,
                        imageCaption: e.target.value,
                      }));
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Alt"}
                    value={navbar.imageAlt}
                    onChange={(e) => {
                      setNavbar((prev) => ({
                        ...prev,
                        imageAlt: e.target.value,
                      }));
                      setIsChanged(true);
                    }}
                  />
                </div>
              )}
              <InputField
                type="text"
                value={navbar.heading}
                isLabel={true}
                lable="Heading"
                onChange={(e) =>
                  setNavbar((prev) => ({ ...prev, heading: e.target.value }))
                }
              />
              <InputField
                type="textarea"
                value={navbar.description}
                isLabel={true}
                lable="Description (max. 300 characters)"
                onChange={(e) => {
                  if (e.target.value.length < 300) {
                    setNavbar((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }));
                  }
                }}
              />
            </div>
            {/* Meta Data */}
            <div className="card grid">
              <InputField
                isLabel={true}
                lable="Slug"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default Service;
